import React, { forwardRef, useState, useEffect } from 'react';

const IosCompatibleInput = forwardRef(({
  type = 'text',
  id,
  name,
  value,
  onChange,
  debounce = 300, // ms (ajout 22/07/2025)
  required = false,
  autoComplete = 'off',
  ...props
}, ref) => {

  // const [internalValue, setInternalValue] = useState(value);
  const [internalValue, setInternalValue] = useState(value ?? '');

  // Met à jour la valeur interne si le parent change (ex: reset)
  //useEffect(() => { setInternalValue(value); }, [value]);
  useEffect(() => { setInternalValue(value ?? ''); }, [value]);

  // Test avec les dépendances (modif du 31/07/2025)
  // useEffect(() => {
  //   const timer = setTimeout(() => {
  //     if (internalValue !== value && onChange) {
  //       onChange({ target: { value: internalValue, name, id } });
  //     }
  //   }, debounce);

  //   return () => clearTimeout(timer);
  // }, [internalValue, debounce, id, name, onChange, value]);

  // const handleChange = (e) => {
  //   setInternalValue(e.target.value);
  // };

  const handleChange = (e) => {
    const nextValue = e.target.value;

    // Mise à jour locale immédiate pour éviter les soucis iOS
    setInternalValue(nextValue);

    // Synchronisation parent immédiate pour éviter formData en retard
    if (onChange) {
      onChange({
        target: {
          name,
          id,
          type,
          value: nextValue,
        },
      });
    }
  };


  return (
    <input
      ref={ref}
      type={type}
      id={id}
      name={name}
      value={internalValue} // valeur totalement contrôlée (modification du 22/07/2025 value => internalValue)
      onChange={handleChange}
      required={required}
      autoComplete={autoComplete}
      autoCorrect="off"
      autoCapitalize="none"
      spellCheck="false"
      data-lpignore="true"
      {...props}
    />
  );
});

export default IosCompatibleInput;

